import { render, staticRenderFns } from "./HowItWorkCandidate.vue?vue&type=template&id=5dde4fc5&"
import script from "./HowItWorkCandidate.vue?vue&type=script&lang=js&"
export * from "./HowItWorkCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports